import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

const UlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ul" sx={styles}>
    {children}
  </Box>
);

export default UlList;
